<template>
    <div class="inner" v-if="isVisible">
        <nav class="cart-navigation" v-if="count">
            <a :href="cartRoute" class="cart-navigation-link">
                <span class="material-icons">shopping_cart</span>
                {{ i18n.kosik }} ({{count}}) <b> {{price}}</b>
            </a>
        </nav>
    </div>
</template>

<script>
    import cart from '../cart.js';

    export default {
        props: {
            isVisible: Boolean,
            cartRoute: String
        },
        data: function () {
            return {
                cart: cart,
                i18n: i18n
            };
        },
        computed: {
            count() {
                return this.cart.getCount();
            },
            price() {
                return this.cart.getPriceFormatted();
            }
        },
        created() {
            cart.update();
        },
        mounted() {
        },
        methods: {}
    };
</script>

<style scoped lang="scss">
    .inner {
        position: fixed;
        top: 50px;
        left: 50%;
        margin-left: -587.5px;
        z-index: 99;

        @media only screen and (max-width: 1215px) {
            left: -20px;
            margin-left: auto;
        }
    }
</style>
